import { KEY_CODE_MAPPING } from "constants-lib/keyCodes"
import isFunction from "lodash/isFunction"

/**
 * Handles the escape key press events for accessibility purposes.
 * @param {Event} e - The key press event object.
 * @param {Function} callback - The function to be called on key press event.
 */
export const handleEscapePress = (e, callback) => {
  const code = e.keyCode || e.which
  if (code === KEY_CODE_MAPPING.ESCAPE) {
    isFunction(callback) && callback()
  }
}
